module.exports = __webpack_public_path__ + "6e0d10f0b06a0499268a24c4ba800276.pdf";